import { render } from "./promocionesdestacadas.vue?vue&type=template&id=6089ba02&scoped=true"
import script from "./promocionesdestacadas.vue?vue&type=script&lang=js"
export * from "./promocionesdestacadas.vue?vue&type=script&lang=js"

import "./promocionesdestacadas.vue?vue&type=style&index=0&id=6089ba02&scoped=true&lang=css"

import exportComponent from "C:\\CEDIS\\cedispage2.0_general_guvi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6089ba02"]])

export default __exports__